import React, { useContext, useState, useEffect } from 'react'
import {
  AMNRadioButtonsGroup,
  AMNTextArea,
  AMNToggleButtonGroup,
  AMNNineCheckbox
} from '@amn/shared'
import {
  Container,
  Grid,
  Typography,
  createMuiTheme,
  Box,
  Button,
  makeStyles,
  ThemeProvider
} from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { containerStyle, noBorderContainerStyle } from '../styles/styles'
import {
  getMetaData,
  updateEvaluationSubmission
} from '../api/proReference.service'
import { useCookies } from 'react-cookie'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import { FormatListNumberedRtlOutlined } from '@material-ui/icons'
import withAppInsights, { appInsights } from '../telemetryService'
import { textFieldTheme, radioButtonTheme } from '../App'

const nineCheckboxTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#0098DB'
    },
    secondary: {
      main: '#003C69'
    }
  },
  typography: {
    body1: {
      fontSize: '16px',
      color: '#003C69'
    }
  }
})

const toggleTheme = createMuiTheme({
  overrides: {
    MuiToggleButton: { // For ListItem, change this to MuiListItem
      root: {
        '&$selected': {// this is to refer to the prop provided by M-UI
          color: 'white !important',
          backgroundColor: '#0098DB !important',
          '&:hover': {
            backgroundColor: '#EBF7FF'
          }
        },
        '&:hover': {
          backgroundColor: '#EBF7FF'
        },
        border: 'none'
      }
    },
    MuiToggleButtonGroup: {
      groupedHorizontal: {
        '&:first-child': {
          margin: '0px'
        },
        '&:not(:first-child)': {
          marginLeft: '0px'
        }
      }
    },
    color: '#003C69 !important',
    font: 'normal normal normal 11px/22px Roboto',
    letterSpacing: 0,
    opacity: 1,
    borderRadius: 0,
    backgroundColor: 'white !important'

  }
})

const ToggleStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      display: 'grid'
    },
    [theme.breakpoints.up('sm')]: {
      width: '91%',
      height: '35px'
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 12,
      width: '91%',
      height: '35px'
    }
  },
  toggleButton: {
    width: '33.3%',
    fontSize: 9,
    textTransform: 'none',
    color: '#003C69 !important',
    font: 'normal normal normal Roboto !important',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      fontSize: 14
    },
    [theme.breakpoints.up('600')]: {
      width: '100%',
      fontSize: 12
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 14,
      height: '35px'
    }
  },
  errorText: {
    color: '#D9553D',
    padding: '1% 0 0 1%'
  }
}))

const griduseStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary
  }
}))

const EvaluationForm = (props) => {
  const classes = containerStyle()
  const classes2 = griduseStyles()
  const toggleClasses = ToggleStyles()
  const theme = useTheme()
  const [errorEval, setErrorEval] = React.useState([
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true
  ])

  const {
    referenceEvaluationRatingTypes,
    referenceEvaluationCategoryTypes,
    referenceAgeTypes,
    updateReference,
    updateEvaluation,
    updateAgeCompetency
  } = props
  let item = []
  item = referenceAgeTypes
    .sort((a, b) => (a.id > b.id ? 1 : -1))
    .map((a) => {
      return {
        name: a.description,
        isChecked: false
      }
    })

  item = item.map(function (x) {
    var result = props.reference.ageCompetencies.filter(
      (item) => item.ageType === x.name
    )
    if (result.length > 0) x.isChecked = true
    return x
  })

  const [items, setItems] = useState(item)
  const handleToggle = (event, categoryIndex) => {
    const foundRatingType = referenceEvaluationRatingTypes.find(
      (item) => parseInt(item.value) === parseInt(event.target.value)
    )
    if (foundRatingType) {
      const foundRatingTypeValue = foundRatingType.value
      updateEvaluation(0, {
        categoryId: parseInt(
          referenceEvaluationCategoryTypes[event.target.id].id
        ),
        category: referenceEvaluationCategoryTypes[event.target.id].description,
        ratingId: parseInt(event.target.value),
        rating:
          foundRatingTypeValue === 1
            ? 'Superior'
            : foundRatingTypeValue === 2
              ? 'Exceeds Standards'
              : foundRatingTypeValue === 3
                ? 'Proficient'
                : 'Does not Meet Standards'
      })
    }

    if (foundRatingType === undefined) updateError(categoryIndex, true)
    else updateError(categoryIndex, false)
  }

  const updateError = (index, isError) => {
    const existingError = errorEval

    existingError[index] = isError
    setErrorEval(existingError)
  }

  const handleCheckboxChange = (event) => {
    setItems(event.target.value)
    const data = event.target.value
      .filter((item) => item.isChecked)
      .map((item) => {
        return {
          ageTypeId: parseInt(
            referenceAgeTypes.find(
              (ageType) => ageType.description === item.name
            ).id
          ),
          ageType: item.name
        }
      })
    updateAgeCompetency(0, data)
  }

  const ExperienceLevelNote = [
    '1 - No Experience, requires education, training and supervision',
    '2 - Intermittent experience/may need support or supervision',
    '3 - Proficient, consistent experience, independent',
    '4 - Expert level; Can teach/supervise others'
  ]

  const sortEvaluationsAlphabetically = (a, b) => {
    if (a.category < b.category) return -1
    if (a.category > b.category) return 1
    return 0
  }

  const amntogglebuttons = () => {
    const sortedEvaluations = props.reference.evaluations.sort(
      sortEvaluationsAlphabetically
    )
    return referenceEvaluationCategoryTypes.map((value, index) => {
      return (
        <div key={index} style={{ width: '100%' }}>
          <div>
            {true && errorEval[index]}
            <Grid item sm={12}>
              <Typography variant='body2'>
                <div style={{ marginBottom: '2%' }}>{value.description}</div>
              </Typography>
            </Grid>
          </div>
          <div>
            <Grid item sm={12}>
              <div style={{ marginBottom: '2%' }}>
                <AMNToggleButtonGroup
                  id={index}
                  data={referenceEvaluationRatingTypes}
                  onChange={(e) => handleToggle(e, index)}
                  userStyle={ToggleStyles}
                  value={sortedEvaluations[index]?.ratingId}
                  required
                  error={props.error && errorEval[index]}
                  theme={toggleTheme}
                  errorText='Required'
                />
              </div>
            </Grid>
          </div>
        </div>
      )
    })
  }

  const amncheckboxes = () => {
    let ischeckbox = false

    return referenceAgeTypes.map((value, index) => {
      return (
        <div key={index}>
          {!ischeckbox ? (
            <div>
              <div
                className={classes.evalution_heading_div}
                style={{ marginBottom: '2%' }}
              >
                <Typography variant='body2'>Age Specific Competency</Typography>
              </div>
              <div style={{ width: '100%' }}>
                <Grid item sm={12}>
                  <div key={index}>
                    <AMNNineCheckbox
                      data={items}
                      size='medium'
                      error={props.error}
                      gridLayout
                      onChange={handleCheckboxChange}
                      errorText='Required'
                      required
                      theme={nineCheckboxTheme}
                    />
                  </div>
                </Grid>

                {(ischeckbox = true)}
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      )
    })
  }

  const employeeEligble = [
    {
      id: '1',
      value: 'Yes'
    },
    {
      id: '2',
      value: 'No'
    }
  ]

  const radioButtonChanged = (event, key) => {
    let bool
    if (event.target.value === 'Yes') bool = true
    else if (event.target.value === 'No') bool = false
    updateReference(0, {
      [key]: bool
    })
  }
  const handleRadioInput = () => {
    if (props.reference.eligibleForRehire === true) return 'Yes'
    else if (props.reference.eligibleForRehire === false) return 'No'
  }

  const empcomments = () => {
    return (
      <div className={classes.inputField}>
        <FormControl component='fieldset'>
          <FormLabel
            component='legend'
            className={classes.chargeExperienceLabel}
            error={props.error && props.reference.eligibleForRehire === null}
          >
            <Typography variant='body2'>
              Is employee eligible for rehire?
            </Typography>
          </FormLabel>
          <ThemeProvider theme={radioButtonTheme}>
            <AMNRadioButtonsGroup
              dir
              data={employeeEligble}
              type
              value={handleRadioInput}
              len={2}
              onChange={(e) => radioButtonChanged(e, 'eligibleForRehire')}
            />
          </ThemeProvider>
        </FormControl>
        <Grid>
          <Typography variant='caption' style={{ color: '#D9553D' }}>
            {props.error && props.reference.eligibleForRehire === null
              ? 'Required'
              : null}
          </Typography>
        </Grid>
      </div>
    )
  }

  const handleChange = (event) => {
    updateReference(0, {
      [event.target.id]: event.target.value
    })
  }

  const commentsection = () => {
    return (
      <div className={classes.eval_compo_div} key=''>
        <Grid item sm={12}>
          <Typography variant='body1' style={{paddingBottom: '5px'}}>
            Please include any additional comments about healthcare professional
          </Typography>
        </Grid>
        <Grid item sm={12}>
          <AMNTextArea
            id='comment'
            label='Comments'
            variant='filled'
            maxCharacter='500'
            value={props.reference.comment}
            error={props.error && !props.reference.comment}
            required
            errorText='Required'
            className={classes.unitDescription}
            onChange={(e) => handleChange(e)}
            theme={textFieldTheme}
          />
        </Grid>
      </div>
    )
  }

  return (
    <div className={classes2.root}>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Container
            style={{ backgroundColor: 'white', border: '1px solid lightgrey' }}
          >
            <div>
              <form className={classes.root} noValidate autoComplete='off'>
                <Typography variant='h6'>Evaluation</Typography>
                <div className={classes.evalution_para_div}>
                  <Typography>
                    Please rate this clinician's performance with the following
                    scale.
                  </Typography>
                </div>
                <Container className={classes.TwoColumnLabelContainer}>
                  <Grid container>
                    {ExperienceLevelNote.map((item) => {
                      return (
                        <Grid item xs={12} key=''>
                          {' '}
                          <Box className={classes.TwoColumnLabel}>{item}</Box>
                        </Grid>
                      )
                    })}
                  </Grid>
                </Container>

                <Grid container spacing={0}>
                  <Grid
                    container
                    item
                    sm={12}
                    justify='center'
                    alignItems='center'
                  >
                    <Grid item xs={12}>
                      {amntogglebuttons()}
                    </Grid>
                    <Grid item xs={12}>
                      {amncheckboxes()}
                    </Grid>
                    <Grid item xs={12}>
                      {empcomments()}
                    </Grid>
                    <Grid item xs={12}>
                      {commentsection()}
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </div>
          </Container>
        </Grid>
      </Grid>
    </div>
  )
}
export default withAppInsights(EvaluationForm)
